import React from 'react'
import CustomHeroImage from '../components/CustomHeroImage/CustomHeroImage';
import WorkCards from '../components/WorkCard/WorkCards';

function Project() {
  return (
    <div>
      <CustomHeroImage 
      heading="PROJECTS"
      text="Some of my recent works"
      />
      <WorkCards />
    </div>
  )
}

export default Project